import React, { Component } from 'react';
import TableHTd from './indexHTd'
import BsyTurnPage from '../BsyTurnPage'

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import './index.css'
import TableTd from "./indexTd";
import { BsyUtils } from '../../utils/Utils';

class BsyTableList extends Component {
    static defaultProps = {
        checkList: [],
        checkListDetail: [],
        checked: false,
        hasTurnPage: true
    }
    constructor(props) {
        super(props);
        this.state = {
            checkList: props.checkList || [],
            checkListDetail: props.checkListDetail || [],
            count: props.count || props.userCont.count,
            not_joined: props.not_joined || props.userCont.not_joined,
            hasTurnPage: props.hasTurnPage,
            users: props.users || props.userCont.users,
            member_list_map: props.member_list_map || props.userCont.member_list_map,
            checked: props.checked,
            multiple: props.hasOwnProperty('multiple') ? props.multiple : true, //列表是否有多选
        }
        this.tableCont = React.createRef()
        this.onDragEnd = this.onDragEnd.bind(this);
    }


    // 重新记录数组顺序
    reorder = (list, startIndex, endIndex) => {
        const result = Array.from(list);

        const [removed] = result.splice(startIndex, 1);

        result.splice(endIndex, 0, removed);
        return result;
    };

    componentDidMount() {
        // document.addEventListener('click', this.hideAlert);
        // document.addEventListener('click', this.removeAlert);
        this.props.getValue && this.props.getValue(this);
        if(this.tableCont.current.clientWidth < this.tableCont.current.children[0].clientWidth){
            this.tableCont.current.classList.add('hasRightShadow')
        }
    }

    // componentWillUnmount() {
    //     document.removeEventListener('click', this.hideAlert)
    //     document.removeEventListener('click', this.removeAlert);
    // }

    // hideAlert = (event) =>{
    //     if(document.getElementsByClassName("BsyAlertListDetail")[0]){
    //         document.getElementsByTagName("body")[0].removeChild(document.getElementsByClassName("BsyAlertListDetail")[0])
    //         document.getElementsByTagName('body')[0].style.overflow = ""
    //     }
    // }

    onDragEnd(result) {
        this.tableCont.current.classList.remove('drag')
        if (!result.destination) {
            return;
        }
        // console.log(result)
        const users = this.reorder(
            this.state.users,
            result.source.index,
            result.destination.index
        );
        // this.props.users = users;
        let data;
        if (result.destination.index === 0) {
            data = {
                "user_id": result.draggableId,  //被移动的成员
                "prev": "",  //前一个成员 没有传空
                "next": users[1]._id  //后一个成员 没有传空
            }
        } else if (result.destination.index === (users.length - 1)) {
            data = {
                "user_id": result.draggableId,  //被移动的成员
                "prev": users[result.destination.index - 1]._id,  //前一个成员 没有传空
                "next": ""  //后一个成员 没有传空
            }
        } else {
            data = {
                "user_id": result.draggableId,  //被移动的成员
                "prev": users[result.destination.index - 1]._id,  //前一个成员 没有传空
                "next": users[result.destination.index + 1]._id  //后一个成员 没有传空
            }
        }
        this.setState({
            users
        }, () => {
            if (this.props.onRowOrder) {
                this.props.onRowOrder(data)
            }
        })
    }

    onDragStart = (result) => {
        this.tableCont.current.classList.add('drag')
    }

    changeCheck = (val) => {
        let checkList = this.state.checkList || [];
        let checkListDetail = this.state.checkListDetail || [];
        return (event) => {
            event.stopPropagation()
            const { users } = this.state
            let checked;
            if (checkList.indexOf(val._id) === -1) {
                checkList.push(val._id);
                checkListDetail.push(val);
                checked = checkList.length === users.length;
                this.setState({ checkList: [...checkList], checked: checked, checkListDetail: checkListDetail },() =>{
                    this.props.onCheck && this.props.onCheck({checkList, checkListDetail, checked})
                })
            } else {
                checkListDetail.splice(checkList.indexOf(val._id), 1);
                checkList.splice(checkList.indexOf(val._id), 1);
                checked = checkList.length === users.length;
                this.setState({ checkList: [...checkList], checked: checked, checkListDetail: checkListDetail },() =>{
                    this.props.onCheck && this.props.onCheck({checkList: [...checkList],checkListDetail: checkListDetail, checked: checked})
                })
            }
        }
    }
    checkAll = () => {
        const { checked, users } = this.state
        if (checked) {
            this.setState({ checkList: [], checked: !checked, checkListDetail: [] },() =>{
                this.props.onCheck && this.props.onCheck({checkList:[],checkListDetail: [], checked: !checked})
            })
        } else {
            const allCheckList = [];
            const checkListDetail = [];
            users.forEach((val, obj) => {
                allCheckList.push(val._id)
                checkListDetail.push(val)
            })
            this.setState({ checkList: [...allCheckList], checked: !checked, checkListDetail: checkListDetail },() =>{
                this.props.onCheck && this.props.onCheck({checkList:[...allCheckList],checkListDetail: checkListDetail, checked: !checked})
            })
        }
    }
    detailShow = (item) => {
        const props = this.props;
        return (event) => {
            event.stopPropagation()

            if (props.onRowClick) {
                props.onRowClick(event, item)
            }
        }
    }

    removeAlert = () => {
        document.getElementsByClassName("BsyAlertMenu").length > 0 && document.getElementsByClassName("BsyAlertMenu")[0].remove()
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            users: nextProps.userCont.users,
            count: nextProps.count,
            hasTurnPage: nextProps.hasTurnPage,
            checkList: nextProps.checkList,
            checked: nextProps.checked,
            checkListDetail: nextProps.checkListDetail,
            not_joined: nextProps.userCont.not_joined,
            multiple: nextProps.hasOwnProperty('multiple') ? nextProps.multiple : true,
        })
    }

    onTableScroll = (event) =>{
        clearTimeout(this.scrollClass);
        this.scrollClass = setTimeout(()=>{
            this.tableAddClass(event.target);
        },30)
    }

    tableAddClass = (t) =>{
        let a = t.children.clientWidth - t.clientWidth;
        t.classList.add('hasRightShadow');
        t.classList.add('hasLeftShadow');
        if(t.scrollLeft <= 0){
            t.classList.remove('hasLeftShadow');
        }
        if(t.scrollLeft + t.clientWidth >= t.scrollWidth - 1){
            t.classList.remove('hasRightShadow');
        }
        if(a <= 0){
            t.classList.remove('hasRightShadow');
            t.classList.remove('hasLeftShadow');
        }
    }

    sortItem = () => {
        const { list, listAll } = this.props;
        const { member_list_map } = this.props.userCont;
        let e = this;
        let i = null;
        let fields = [];
        let sorts =[];
        let a = new window.FX.ConfirmDialog({
          title: React.language("dash.sort.setting"),
          width: 600,
          text4Ok: React.language("ok"),
          hasSeparator: !0,
          onContentCreate: function (t) {
            i = t
          },
          onOk: function () {
            let value = n.getSorts();
            let sortsList = [];
            value.map((val)=>{
                window.FX.Utils.forEach(val,function (obj){
                    sortsList.push(obj)
                })
            })
            e.props.onSortItem && e.props.onSortItem(sortsList)
            a.close()
          }
        });
        a.show();
        fields = listAll.map((val, index)=>{
            return val.value && {
                title: val.value,
                tag: val.key,
                type: 'text'
            }
        })

        member_list_map.map((val, index)=>{
            var j = {};
            j[val] = 1;
            sorts.push(j);
        })

        let n = new window.FX.DashSortPane({
          renderEl: i,
          fields: fields,
          hasFieldSorts: false,
          maxCount: 11,
          sorts
        })
    }

    render() {
        const { list, styleType, limit, skip, noMenu, hasDelBtn, noDarg, skipChange, listLimitChange, deptRefresh, listFilterChange, hasSetIcon } = this.props;
        const { checkList, users, count, checked, multiple, hasTurnPage } = this.state;
        return (
            <div className={styleType ? "BsyTableList " + styleType : "BsyTableList"}>
                <div className="grid-table" ref={this.tableCont} onScroll={this.onTableScroll}>
                    <table cellPadding="0" cellSpacing="0">
                        {/* <colgroup>
                            <col style={{ width: "20px" }} />
                            <col style={{ width: "34px" }} />
                            {
                                list.map((val, key) => {
                                    return <col style={{ width: val.width}}/>
                                })
                            }
                            {!noMenu && <col style={{ width: "32px"}} />}
                            {hasDelBtn && <col style={{ width: "32px" }} />}
                        </colgroup> */}
                        <thead>
                            <tr>
                                <td className={"darg"} style={{ width: "20px" }}>
                                    <div className="cel" style={{width: "20px", maxWidth: "20px"}}>
                                        <i style={{width: 16, height: 16, display: "block"}} />
                                    </div>
                                </td>
                                
                                {
                                    multiple ?
                                    <td className={"check"} style={{ width: "34px" }}><div onClick={this.checkAll} className="checkBtn" style={{ width: "34px" }}><i className={checked ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}>

                                        </i></div></td> : ''
                                }              
                                
                                {
                                    list.map((val, key) => {
                                        return <TableHTd key={key} val={val} />
                                    })
                                }
                                {!noMenu && <td className="menuTd" style={{ width: "32px", minWidth:"32px", right: 0 }}>
                                    {BsyUtils.isSysManager() && hasSetIcon && <div className="icon-cont" onClick={this.sortItem} style={{ width: "30px", height: "30px"}}>
                                        <i className="icon-bsy-iconshezhi1"></i>
                                    </div>}
                                </td>}
                                {hasDelBtn && <td className="DelBtn" style={{ width: "32px", minWidth:"32px" }}>

                                </td>}
                            </tr>
                        </thead>
                        <DragDropContext onDragStart={this.onDragStart} onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <tbody
                                        {...provided.droppableProps}
                                        // 为了使 droppable 能够正常工作必须 绑定到最高可能的DOM节点中provided.innerRef.
                                        ref={!noDarg ? provided.innerRef : null}
                                    >
                                        {users.map((item, index) => (
                                            <Draggable shouldRespectForcePress={true} key={item._id} draggableId={item._id}
                                                index={index}>
                                                {(provided, snapshot) => (
                                                    <tr
                                                        className={index % 2 === 1 ? "even" : ""}
                                                        ref={provided.innerRef}
                                                        {...provided.draggableProps}
                                                        onClick={this.detailShow(item)}
                                                    >
                                                        {!noDarg ? <td className={"darg"} style={{ width: "20px", maxWidth: "20px" }} {...provided.dragHandleProps}>
                                                            <i className="icon-drag-table" />
                                                        </td> : <td className={"darg"} style={{ width: "20px", maxWidth: "20px" }}>
                                                            <i style={{width: 16, height: 16, display: "block"}} />
                                                        </td>}
                                                        {
                                                            multiple ?
                                                                <td className={"check"} style={{ width: "34px" }}><div onClick={this.changeCheck(item)} className="checkBtn" style={{ width: "34px" }}><i className={(checkList && checkList.indexOf(item._id) !== -1) ? "icon-bsy-iconxuanzhong" : "icon-bsy-check2"}>

                                                                </i></div></td>
                                                                : ''
                                                        }
                                                        {
                                                            list.map((value, obj) => {
                                                                return <TableTd key={value.key + obj} value={value}
                                                                    colVal={item} />
                                                            })
                                                        }
                                                        {!noMenu && <td className="menuTd" style={{ width: "32px", minWidth:"32px", right: 0 }}>
                                                            <div className="icon-cont">
                                                                <i className="icon-flow-other" />
                                                            </div>
                                                        </td>}
                                                        {hasDelBtn && <td className="DelBtn" style={{ width: "32px", minWidth:"32px" }}>
                                                            <div className="icon-cont">
                                                                <i className="icon-trasho" />
                                                            </div>
                                                        </td>}
                                                    </tr>
                                                )}
                                            </Draggable>
                                        ))}
                                        {provided.placeholder}
                                    </tbody>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </table>
                </div>
                {hasTurnPage && <BsyTurnPage 
                    skipChange={skipChange}
                    listLimitChange={listLimitChange}
                    deptRefresh={deptRefresh}
                    onBsyTurnPageMid={e => {
                        if(this.props.onBsyTurnPageMid) 
                            return  this.props.onBsyTurnPageMid();
                        return '';
                    }}
                    listFilterChange={listFilterChange} limit={limit} skip={skip} count={count} styleType={styleType} />}
            </div>
        );
    }
}

export default BsyTableList;